import {
    CartProductCard,
    EmptyState,
} from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { ReactComponent as ShoppingCartSvg } from "../../../common/svgs/shopping-cart.svg";
import { useCart } from "../hooks/useCart";
import { useCartPageLoading } from "../hooks/useCartPageLoading";
import { CartProductCardsSkeleton } from "./CartPageSkeletons";

export const CartPageContent = (): JSX.Element => {
    const { pendingOrder, cartLabels, removeProductById, isRemovingProduct } =
        useCart();
    const isPageLoading = useCartPageLoading();

    if (isPageLoading) {
        return <CartProductCardsSkeleton />;
    }

    const orderLines = pendingOrder?.order_lines ?? [];

    if (!orderLines.length) {
        return (
            <EmptyState
                Icon={ShoppingCartSvg}
                title={cartLabels.emptyTitle}
                description={cartLabels.emptyDescription}
            />
        );
    }

    return (
        <div className="p-cart-page__content">
            <div className="p-cart-page__items">
                {orderLines.map((line) => (
                    <CartProductCard
                        key={line.id}
                        id={String(line.refurbished_product_id)}
                        name={line.product_name}
                        image={line.product_image}
                        status={cartLabels.refurbishedStatus}
                        grade={line.grade_label}
                        price={line.discount_grade_price}
                        originalPrice={
                            line.product_price !== line.discount_grade_price
                                ? line.product_price
                                : undefined
                        }
                        serialNr={line.serial_number}
                        artNr={line.product_identifier}
                        isDeleting={isRemovingProduct(
                            line.refurbished_product_id,
                        )}
                        onDelete={(id: string) =>
                            void removeProductById(Number(id))
                        }
                    />
                ))}
            </div>
        </div>
    );
};
